module.exports = __webpack_public_path__ + "static/media/logo.ba7596d0.png";